function updateSliderAlignment() {
    const categorySections = document.querySelectorAll('.category-slider-section');
    categorySections.forEach(section => {
        const slider = section.querySelector('.category-slider');
        if (slider.scrollWidth <= slider.clientWidth) {
            slider.style.justifyContent = 'center';
        } else {
            slider.style.justifyContent = 'flex-start';
        }
        section.classList.add('show-categories');
    });
}

document.addEventListener('DOMContentLoaded', updateSliderAlignment);
window.addEventListener('resize', updateSliderAlignment);
